import React, { useRef, useState } from "react";

type TooltipProps = {
  text?: string;
  content?: React.ReactNode;
  children: React.ReactNode;
};

export const Tooltip = ({ text, content, children }: TooltipProps) => {
  const wrapperRef = useRef<HTMLSpanElement>(null);
  const tooltipRef = useRef<HTMLSpanElement>(null);
  const [visible, setVisible] = useState(false);

  const alignTooltip = () => {
    const wrapper = wrapperRef.current;
    const tooltip = tooltipRef.current;
    if (!wrapper || !tooltip) return;

    const padding = 8;

    tooltip.style.visibility = "hidden";
    tooltip.style.opacity = "1";

    const wrapperRect = wrapper.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();
    const viewportWidth = window.innerWidth;

    let left =
      wrapperRect.left +
      wrapperRect.width / 2 -
      tooltipRect.width / 2;

    left = Math.max(padding, left);
    left = Math.min(
      viewportWidth - tooltipRect.width - padding,
      left
    );

    const top = wrapperRect.bottom + 4;

    tooltip.style.left = `${left}px`;
    tooltip.style.top = `${top}px`;
    tooltip.style.visibility = "visible";
  };

  const show = () => {
    setVisible(true);
    requestAnimationFrame(alignTooltip);
  };

  const hide = () => {
    setVisible(false);
  };

  return (
    <span
      ref={wrapperRef}
      className="tooltip-wrapper"
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={hide}
    >
      {children}

      <span
        ref={tooltipRef}
        className="tooltip-content"
        role="tooltip"
        style={{ opacity: visible ? 1 : 0 }}
      >
        {content ?? text}
      </span>
    </span>
  );
};
